/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'

const getAllApplication = param => {
    return axiosInstance.post(`/api/gcadmin/v1/application/getAll`,param).then(res => res.data)
}
const createApplication = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/application/create`,app).then(res => res.data)
}
const editApplication = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/application/update`,app).then(res => res.data)
}
const getAppHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/application/get-history`,param).then(res => res.data)
}
export {
    getAllApplication,
    createApplication,
    editApplication,
    getAppHistory
}
